__turbopack_context__.v({
  "ctaStyle": "ctaStyle-module__VTQhHa__ctaStyle",
  "ctaTypeStyle": "ctaStyle-module__VTQhHa__ctaTypeStyle",
});
